module.exports = __webpack_public_path__ + "media/images/sp/special_reports/separator_skyblue-97ebdeef62dc103093712087fd62158c.jpg";